module.exports = __webpack_public_path__ + "img/driving-sales-home-for-the-holidays-img-2.e384ea1a.jpg";